
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./components/HomePage";
import ContactUs from "./components/ContactUs";
import Partner from "./components/Partner";
import Gallery from "./components/Gallery";
import Donate from "./components/Donate";
import Projects from "./components/Projects";
import Events from "./components/Events";
import WhoWeAre from "./components/WhoWeAre";
import OurCampus from "./components/OurCampus";
import ReportsMedia from "./components/ReportsMedia";
import FoundationalPhilosophy from "./components/FoundationalPhilosophy";
import Sports from "./components/Sports";
import CommunityInitiatives from "./components/CommunityInitiatives";
import Livelihoods from "./components/Livelihoods";
import Health from "./components/Health";
import Education from "./components/Education";
import SkillDevelopment from "./components/SkillDevelopment";
import Abled from "./components/Abled";
import ContactForm from "./components/ContactForm";





function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="partner" element={<Partner />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="donate" element={<Donate />} />
          <Route path="projects" element={<Projects />} />;
          <Route path="events" element={<Events />} />;
          <Route path="who-we-are" element={<WhoWeAre />} />;
          <Route path="our-campus" element={<OurCampus />} />;
          <Route path="reports-media" element={<ReportsMedia />} />;
          <Route path="foundational-philosophy" element={<FoundationalPhilosophy />} />;
          <Route path="sports" element={<Sports />} />;
          <Route path="community-initiatives" element={<CommunityInitiatives />} />;
          <Route path="livelihoods" element={<Livelihoods />} />;
          <Route path="health" element={<Health />} />;
          <Route path="education" element={<Education />} />;
          <Route path="skill-development" element={<SkillDevelopment />} />
          <Route path="abled" element={<Abled />} />
          <Route path="contact-form" element={<ContactForm />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
